function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var AttributeTracker = /*#__PURE__*/function () {
  function AttributeTracker(attribute, createManager) {
    var _this = this;

    _classCallCheck(this, AttributeTracker);

    this.attribute = attribute;
    this.createManager = createManager;
    this._managers = new Map();
    this._attributeSelector = "[".concat(attribute, "]");
    this._mutationObserver = new MutationObserver(function (mutations) {
      var _iterator = _createForOfIteratorHelper(mutations),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var mutation = _step.value;

          _this._processMutation(mutation);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
  }

  _createClass(AttributeTracker, [{
    key: "attachRoot",
    value: function attachRoot(element) {
      var _this2 = this;

      this._forEachMatchingUnder(element, function (match) {
        return _this2._detect(match);
      });

      this._mutationObserver.observe(element, {
        attributes: true,
        attributeFilter: [this.attribute],
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "shutdown",
    value: function shutdown() {
      var _this3 = this;

      this._mutationObserver.disconnect();

      var _iterator2 = _createForOfIteratorHelper(this._managers.values()),
          _step2;

      try {
        var _loop = function _loop() {
          var manager = _step2.value;

          if (manager) {
            _this3._errorBoundry(function () {
              return manager.shutdown();
            });
          }
        };

        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._managers.clear();
    }
  }, {
    key: "getManager",
    value: function getManager(element) {
      return this._managers.get(element);
    }
  }, {
    key: "_detect",
    value: function _detect(element) {
      var _this4 = this;

      var manager = null;

      this._errorBoundry(function () {
        if (_this4._managers.has(element)) {
          throw new Error('Double detect in AttributeTracker');
        }

        manager = _this4.createManager(element);
      });

      if (manager) {
        this._managers.set(element, manager);
      }
    }
  }, {
    key: "_update",
    value: function _update(element) {
      var manager = this._managers.get(element);

      if (manager && manager.update) {
        this._errorBoundry(function () {
          return manager.update();
        });
      } else {
        this._remove(element);

        this._detect(element);
      }
    }
  }, {
    key: "_remove",
    value: function _remove(element) {
      var manager = this._managers.get(element);

      if (manager && manager.shutdown) {
        this._errorBoundry(function () {
          return manager.shutdown();
        });
      }

      this._managers.delete(element);
    }
  }, {
    key: "_processMutation",
    value: function _processMutation(mutation) {
      if (mutation.type === 'childList') {
        this._processChildListMutation(mutation);
      } else if (mutation.type === 'attributes') {
        this._processAttributesMutation(mutation);
      }
    }
  }, {
    key: "_processChildListMutation",
    value: function _processChildListMutation(_ref) {
      var _this5 = this;

      var removedNodes = _ref.removedNodes,
          addedNodes = _ref.addedNodes;

      this._forEachMatchingIn(removedNodes, function (match) {
        return _this5._remove(match);
      });

      this._forEachMatchingIn(addedNodes, function (match) {
        return _this5._detect(match);
      });
    }
  }, {
    key: "_processAttributesMutation",
    value: function _processAttributesMutation(_ref2) {
      var target = _ref2.target;

      if (this._managers.has(target)) {
        this._processAttributeUpdateToTracked(target);
      } else {
        this._processAttributeUpdateToUntracked(target);
      }
    }
  }, {
    key: "_processAttributeUpdateToTracked",
    value: function _processAttributeUpdateToTracked(element) {
      if (element.hasAttribute(this.attribute)) {
        this._update(element);
      } else {
        this._remove(element);
      }
    }
  }, {
    key: "_processAttributeUpdateToUntracked",
    value: function _processAttributeUpdateToUntracked(element) {
      if (element.hasAttribute(this.attribute)) {
        this._detect(element);
      }
    }
  }, {
    key: "_forEachMatchingIn",
    value: function _forEachMatchingIn(nodes, callback) {
      var _iterator3 = _createForOfIteratorHelper(nodes),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var node = _step3.value;

          this._forEachMatchingUnder(node, callback);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }
    }
  }, {
    key: "_forEachMatchingUnder",
    value: function _forEachMatchingUnder(node, callback) {
      if (node.hasAttribute && node.hasAttribute(this.attribute)) {
        callback(node);
      }

      if (node.querySelectorAll) {
        var _iterator4 = _createForOfIteratorHelper(node.querySelectorAll(this._attributeSelector)),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var match = _step4.value;
            callback(match);
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      }
    }
  }, {
    key: "_errorBoundry",
    value: function _errorBoundry(callback) {
      try {
        callback();
      } catch (error) {
        console.error('[Motion] An internal error occurred:', error);
      }
    }
  }]);

  return AttributeTracker;
}();

export { AttributeTracker as default };